import { render, staticRenderFns } from "./PasswordSetting.vue?vue&type=template&id=e48246ec&scoped=true&"
import script from "./PasswordSetting.vue?vue&type=script&lang=ts&"
export * from "./PasswordSetting.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordSetting.vue?vue&type=style&index=0&id=e48246ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48246ec",
  null
  
)

export default component.exports